import type { schema } from 'database';
import type { NormalizedSortBy } from '../_components/types';

export const NORMALIZED_SORT_BY_MAP: Record<
  schema.SortByOption,
  NormalizedSortBy
> = {
  mostRecent: 'most-recent',
  leastRecent: 'least-recent',
  titleAsc: 'title-asc',
  titleDesc: 'title-desc',
};
